// src/services/companyService.ts
import api from './api';
import type { ICompany } from '../types/company';

const getFeaturedCompanies = async (): Promise<ICompany[]> => {
  try {
    const response = await api.get<ICompany[]>('/companies/featured');
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch featured companies.');
  }
};

const getAllCompanies = async (): Promise<ICompany[]> => {
  try {
    const response = await api.get<ICompany[]>('/companies');
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch companies.');
  }
};

// ✨ NEW: Function to create a company
const createCompany = async (payload: { name: string; logo: string; featured: boolean }): Promise<ICompany> => {
    try {
      const response = await api.post<ICompany>('/companies', payload);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to create company.');
    }
  };

// ✨ NEW: Function to update a company
const updateCompany = async (id: string, payload: Partial<ICompany>): Promise<ICompany> => {
    try {
      const response = await api.put<ICompany>(`/companies/${id}`, payload);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to update company.');
    }
  };

// ✨ NEW: Function to delete a company
const deleteCompany = async (id: string): Promise<string> => {
    try {
      const response = await api.delete<{ message: string }>(`/companies/${id}`);
      return response.data.message;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to delete company.');
    }
  };

const companyService = {
    getFeaturedCompanies,
    getAllCompanies,
    createCompany,
    updateCompany,
    deleteCompany,
};

export default companyService;